function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  fill: "#D2D2D2",
  cx: 5.5,
  cy: 5.5,
  r: 5.5
}), React.createElement("path", {
  d: "M5.123 6.196l2.1196-2.1195a.5897.5897 0 0 1 .8339 0l.1386.1386a.5897.5897 0 0 1 0 .8339L5.6903 7.5738a.588.588 0 0 1-.4263.1726.5898.5898 0 0 1-.6389-.1192L3.143 6.1959a.5897.5897 0 0 1-.0146-.8338l.1361-.141a.5897.5897 0 0 1 .8338-.0145l1.0247.9895z",
  fill: "#FFF"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 11,
    height: 11
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/GreyCircleTick.a38a1d8e.svg";
export { SvgComponent as ReactComponent };